var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 868.71 844.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #b03839;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m680.55,418.93H59.86c-33.04,0-59.86,26.77-59.86,59.82v180c0,33.04,26.81,59.86,59.86,59.86h620.69c33.04,0,59.81-26.82,59.81-59.86v-180c0-33.04-26.77-59.82-59.81-59.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m261.62,0c-57.67,0-104.61,46.93-104.61,104.65v113.7c0,14.52,41.84,15.41,41.84,0v-113.7c0-34.64,28.2-62.76,62.85-62.76h271.34v185.3c0,57.71,46.98,104.65,104.65,104.65h189.13v408.19c0,34.64-28.12,62.81-62.81,62.81h-506.95c-20.29,0-19.74,41.88,0,41.88h506.95c57.75,0,104.69-46.93,104.69-104.69v-103.13h0v-334.78L562.55,0h-300.93Zm323.08,91.26l188.75,186.27h-135.33c-29.47,0-53.42-23.99-53.42-53.42V91.26Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m118.92,461.11c14.76-2.51,35.49-4.4,64.7-4.4s50.57,5.65,64.7,16.96c13.51,10.68,22.61,28.27,22.61,49s-6.91,38.32-19.47,50.25c-16.33,15.39-40.52,22.3-68.79,22.3-6.28,0-11.94-.31-16.33-.94v75.7h-47.43v-208.87Zm47.43,96.11c4.08.94,9.11,1.26,16.02,1.26,25.44,0,41.15-12.88,41.15-34.55,0-19.47-13.51-31.09-37.38-31.09-9.74,0-16.33.94-19.79,1.88v62.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m301.4,461.11c17.59-2.83,40.52-4.4,64.7-4.4,40.2,0,66.27,7.22,86.69,22.61,21.99,16.33,35.81,42.4,35.81,79.78,0,40.52-14.76,68.47-35.18,85.75-22.3,18.53-56.22,27.33-97.68,27.33-24.81,0-42.4-1.57-54.34-3.14v-207.93Zm48.06,172.75c4.08.94,10.68.94,16.65.94,43.34.31,71.61-23.56,71.61-74.12.31-43.97-25.44-67.21-66.59-67.21-10.68,0-17.59.94-21.67,1.88v138.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m520,458.28h129.4v39.26h-81.35v48.37h76.01v38.95h-76.01v85.12h-48.06v-211.69Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfExport);
export default __webpack_public_path__ + "static/media/pdfExport.d4e8d5bfe6cd9c3f28319219d0f1daf5.svg";
export { ForwardRef as ReactComponent };